export default "__VITE_ASSET__CVmQbxuA__"